// export const BASE = "https://towson-api.devtechnosys.tech/";

// export const API_BASE   = "http://172.16.11.182:3000/api/admin";
// export const IMAGE_BASE = 'http://172.16.11.182:3000/';
export const API_BASE   = "https://gullykings-api.devtechnosys.tech/api/admin";
export const IMAGE_BASE = 'https://gullykings-api.devtechnosys.tech/';
// export const API_BASE = BASE + "admin";

export const MOBILE_REGEX = /^[0-9]{10}$/;

export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&~"^+-/=,.?(){}[|\]<>:'_;*?])[A-Za-z\d#$@!%^&~"^+-/=,.?(){}[|\]<>:'_;*?]{8,}$/g;

export const EMAIL_REGEX =
  /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;

  export const URL_REGEX = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;
export const NOSPACE_REGEX = /^(?!\s+$).*/;

export const NOSPACE = "Spaces are not allowed";

export const MULTIPLESPACE = /  +/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;

export const REMOVENBSP = /&nbsp;/g;

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const STATUS_OPTIONS = [
  { value: false, label: "Active" },
  { value: true, label: "Inactive" },
];
export const Verification_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];
export const PLAN_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const AUDIO_FORMATS = ["audio/mpeg", "audio/wav", "audio/ogg"];
